module.exports = __webpack_public_path__ + "static/media/page04_front.3cd21c6b.png";